import styled from "styled-components";
import { Type, Select, Button } from "discover.medical.react-component-library";

export const StyledMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `0 ${theme.space.md} `};
`;

export const StyledValidationMessage = styled(Type)`
  display: inline-block;
  margin-bottom: ${({ theme }) => `${theme.space.md}`};
`;

export const StyledFieldsContainer = styled.div`
  padding: 0 ${({ theme }) => `${theme.space.md}`};
`;

export const StyledFieldWrapper = styled.div`
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.space.md};
  }

  & label {
    font-size: ${({ theme }) => `${theme.font.size.md}`}!important;
    font-weight: ${({ theme }) => `${theme.font.weight.bold}`}!important;
  }
`;

export const StyledSelect = styled(Select)`
  select {
    font-family: ${({ theme }) => `${theme.font.family.base}`};
  }
`;

export const StyledTextContainer = styled(Type)`
  display: flex;
  flex-direction: column;
`;

export const StyledCancelButton = styled(Button)`
  margin-left: ${({ theme }) => `${theme.space.lg}`};
`;
